import Sticky from "./sticky";

export default Sticky;
